
import { Divider, Popover, Typography } from '@mui/material';
import api from '../../../services/api';

import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import './style.css';
import { Load } from '../../../components/Load';
import { Sidebar } from '../../../components/Sidebar';
import { Header } from '../../../components/Header';
import { Main } from '../../../components/Main';

import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../../components/FormGroup';
import { Label } from '../../../components/Label';
import InputMask from 'react-input-mask';
import AlertMessage from '../../../components/Alert';
import { Autocomplete, FormControl, Input, MenuItem, TextField } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import SelectInput from '@mui/material/Select/SelectInput';

import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimeField } from '@mui/x-date-pickers/TimeField';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export function PgrRiscoEditar() {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    });

    const { idEmpresa } = useParams();
    const { idRisco } = useParams();


    // const [value, setValue] = React.useState<Dayjs | null>(dayjs('2022-04-17T15:30'));

    // Definindo estados para os campos da tabela pgr_riscos
    const [categoria, setCategoria]: any = useState([]);
    const [idCategoria, setIdCategoria] = useState('');

    const [risco, setRisco] = useState<any>(null);
    const [limiteDeTolerancia, setLimiteDeTolerancia] = useState('');
    const [limiteDeToleranciaUnd, setLimiteDeToleranciaUnd] = useState('');
    const [nivelDeAcao, setNivelDeAcao] = useState('');
    const [nivelDeAcaoUnd, setNivelDeAcaoUnd] = useState('');
    const [meioDePropagacao, setMeioDePropagacao] = useState('');
    const [frequencia, setFrequencia] = useState('');
    const [classificacaoDoEfeito, setClassificacaoDoEfeito] = useState('');
    const [probabilidade, setProbabilidade] = useState('');
    const [severidade, setSeveridade] = useState('');
    const [tempoDeExposicao, setTempoDeExposicao] = React.useState<Dayjs | null>(dayjs());
    const [dataDaMedicao, setDataDaMedicao] = useState<Dayjs | null>(null);
    const [medicao, setMedicao] = useState('');
    const [medicaoUnd, setMedicaoUnd] = useState('');
    const [medicaoAtenuada, setMedicaoAtenuada] = useState('');
    const [medicaoAtenuadaUnd, setMedicaoAtenuadaUnd] = useState('');
    const [empresaQueRealizouAMedicao, setEmpresaQueRealizouAMedicao] = useState('');
    const [metodo, setMetodo] = useState('');
    const [fonteGeradora, setFonteGeradora] = useState('');
    const [epi, setEpi] = useState('');
    const [utilizaEpi, setUtilizaEpi] = useState('');
    const [utilizaEpc, setUtilizaEpc] = useState('');
    const [intensidade, setIntensidade] = useState('');
    const [tecnicaUtilizada, setTecnicaUtilizada] = useState('');
    const [acao, setAcao] = useState('');
    const [evidencia, setEvidencia] = useState('');
    const [possiveisDanosASaude, setPossiveisDanosASaude] = useState('');
    const [medidasDeControleExistentes, setMedidasDeControleExistentes] = useState('');
    const [medidasDeControlePropostas, setMedidasDeControlePropostas] = useState('');
    const [cronograma, setCronograma] = useState('');
    const [formasDeAcompanhamento, setFormasDeAcompanhamento] = useState('');
    const [afericaoDosResultados, setAfericaoDosResultados] = useState('');
    const [probabilidadePgr, setProbabilidadePgr] = useState('');
    const [severidadePgr, setSeveridadePgr] = useState('');
    const [riscos, setRiscos]: any = useState([]);
    const [categorias, setCategorias]: any = useState([]);
    const [unidades, setUnidades] = useState([]);

    const [meiosPropagacao, setMeiosPropagacao] = useState([]);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

    useEffect(() => {
        async function buscarMeiosPropagacao() {
            try {
                const resposta = await api.get('base-meio-propagacao');
                setMeiosPropagacao(resposta.data);
            } catch (erro) {
                console.error("Erro ao buscar meios de propagação", erro);
            }
        }

        buscarMeiosPropagacao();
    }, []);



    async function buscarDadosRisco() {
        setIsLoading(true); // Ativa o indicador de carregamento
        try {
            const resposta = await api.get(`listar-risco/${idEmpresa}/${idRisco}`); // Ajuste o endpoint conforme necessário
            const dados = resposta.data[0];
            if (dados) {
                const categoriaEncontrada = categorias.find((cat: any) => cat.id === dados.categoria);
                setCategoria(categoriaEncontrada ? categoriaEncontrada.categoria : '');
                setIdCategoria(dados.categoria);
                setRisco(dados.risco);
                setLimiteDeTolerancia(dados.limite_de_tolerancia);
                setLimiteDeToleranciaUnd(dados.id_limite_de_tolerancia_unidade);
                setNivelDeAcao(dados.nivel_de_acao);
                setNivelDeAcaoUnd(dados.id_nivel_de_acao_unidade);
                setMeioDePropagacao(dados.id_meio_de_propagacao);
                setFrequencia(dados.frequencia);
                setClassificacaoDoEfeito(dados.classificacao_do_efeito);
                setProbabilidade(dados.probabilidade);
                setSeveridade(dados.severidade);
                setTempoDeExposicao(dados.tempo_de_exposicao ? dayjs(dados.tempo_de_exposicao) : null);
                setDataDaMedicao(dados.data_da_medicao ? dayjs(dados.data_da_medicao) : null);
                setMedicao(dados.medicao);
                setMedicaoUnd(dados.medicao ? dados.medicao.replace(/[0-9]/g, '').replace(" ", "") : '')
                setMedicaoAtenuada(dados.medicao_atenuada);
                setMedicaoAtenuadaUnd(dados.medicao_atenuada ? dados.medicao_atenuada.replace(/[0-9]/g, '').replace(" ", "") : '');
                setEmpresaQueRealizouAMedicao(dados.empresa_que_realizou_a_medicao);
                setMetodo(dados.metodo);
                setFonteGeradora(dados.fonte_geradora);
                setEpi(dados.epi); // Supondo que epi seja um campo diretamente mapeável
                setUtilizaEpi(dados.utiliza_epi);
                setUtilizaEpc(dados.utiliza_epc);
                setIntensidade(dados.intensidade);
                setTecnicaUtilizada(dados.tecnica_utilizada);
                setAcao(dados.acao);
                setEvidencia(dados.evidencia);
                setPossiveisDanosASaude(dados.possiveis_danos_a_saude);
                setMedidasDeControleExistentes(dados.medidas_de_controle_existentes);
                setMedidasDeControlePropostas(dados.medidas_de_controle_propostas);
                setCronograma(dados.cronograma);
                setFormasDeAcompanhamento(dados.formas_de_acompanhamento);
                setAfericaoDosResultados(dados.afericao_dos_resultados);
                setProbabilidadePgr(dados.probabilidade_pgr);
                setSeveridadePgr(dados.severidade_pgr);
            }

        } catch (erro) {
            console.error("Erro ao buscar dados do risco", erro);
        }
        setIsLoading(false); // Desativa o indicador de carregamento
    }

    useEffect(() => {
        buscarDadosRisco();
    }, [idEmpresa, idRisco, categorias]); // Dependência para re-executar o efeito se o idRisco mudar


    useEffect(() => {
        async function buscarUnidades() {
            try {
                const resposta = await api.get('base-unidades');
                setUnidades(resposta.data);
            } catch (erro) {
                console.error("Erro ao buscar unidades", erro);
            }
        }

        buscarUnidades();
    }, []);


    useEffect(() => {
        async function buscarCategorias() {
            try {
                const resposta = await api.get('base-cat-riscos');
                const dados = resposta.data;
                setCategorias(dados);
            } catch (erro) {
                console.error("Erro ao buscar categorias", erro);
            }
        }

        buscarCategorias();
    }, []);
    useEffect(() => {
        async function buscarRiscos() {
            try {
                const resposta = await api.get('base-riscos');
                const dados = resposta.data;
                setRiscos(dados);
            } catch (erro) {
                console.error("Erro ao buscar riscos", erro);
            }
        }

        buscarRiscos();
    }, []);



    const [selectValues, setSelectValues] = useState({
        selectTolerancia: limiteDeTolerancia ? limiteDeTolerancia.replace(/[0-9]/g, '').replace(" ", "") : '',
        selectAcao: nivelDeAcao ? nivelDeAcao.replace(/[0-9]/g, '').replace(" ", "") : '',
        selectProbabilidade: probabilidade ? probabilidade : '',
        selectSeveridade: '',
        selectMedAte: '',
        selectMed: '',
        selectUtilEPI: '',
        selectUtilEPC: '',
        selectiIntens: '',
        selectProbabilidadePgr: '',
        selectSeveridadePgr: ''
    });




    const handleSubmit = async (event: any) => {
        event.preventDefault();

        // Compilando os dados do formulário
        const formData = {
            categoria: idCategoria,
            risco,
            limite_de_tolerancia: `${limiteDeTolerancia}`,
            id_limite_de_tolerancia_unidade: `${limiteDeToleranciaUnd}`,
            nivel_de_acao: `${nivelDeAcao}`,
            id_nivel_de_acao_unidade: `${nivelDeAcaoUnd}`,
            id_meio_de_propagacao: meioDePropagacao,
            frequencia,
            classificacao_do_efeito: classificacaoDoEfeito,
            probabilidade,
            severidade,
            tempo_de_exposicao: tempoDeExposicao ? tempoDeExposicao.format() : '',
            data_da_medicao: dataDaMedicao ? dataDaMedicao.format('YYYY-MM-DD') : '',
            medicao: `${medicao} ${medicaoUnd}`,
            medicao_atenuada: `${medicaoAtenuada} ${medicaoAtenuadaUnd}`,
            empresa_que_realizou_a_medicao: empresaQueRealizouAMedicao,
            metodo,
            fonte_geradora: fonteGeradora,
            epi,
            utiliza_epi: utilizaEpi,
            utiliza_epc: utilizaEpc,
            intensidade,
            tecnica_utilizada: tecnicaUtilizada,
            acao,
            evidencia,
            possiveis_danos_a_saude: possiveisDanosASaude,
            medidas_de_controle_existentes: medidasDeControleExistentes,
            medidas_de_controle_propostas: medidasDeControlePropostas,
            cronograma,
            formas_de_acompanhamento: formasDeAcompanhamento,
            afericao_dos_resultados: afericaoDosResultados,
            probabilidade_pgr: probabilidadePgr,
            severidade_pgr: severidadePgr
        };


        try {
            // Use a URL correta para o seu backend aqui
            const url = `editar-risco/${idEmpresa}/${idRisco}`;
            const response = await api.put(url, formData);
            console.log('Resposta do servidor:', response.data);
            setAlert({ message: 'Dados atualizados com sucesso', variant: 'success', show: true });
        } catch (error) {
            console.error('Erro ao enviar o formulário:', error);
            setAlert({ message: 'Erro ao atualizar dados', variant: 'danger', show: true });
        }
    };

    return (
        <>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Form onSubmit={handleSubmit}>
                    <h3>Editar Risco</h3>
                    <Row className="my-4">

                        <Col md={6}>
                            <Label title='Risco *' htmlFor="risco" />

                            <Autocomplete
                                id='risco'
                                value={risco}
                                onChange={(event, newValue) => {
                                    setRisco(newValue);

                                    // Encontrar a categoria correspondente
                                    const riscoSelecionado = riscos.find((risco: any) => risco.nome === newValue);
                                    if (riscoSelecionado) {
                                        // Atualizar o estado da categoria com o nome da categoria
                                        const categoriaCorrespondente = categorias.find((cat: any) => cat.id === riscoSelecionado.id_cat);
                                        if (categoriaCorrespondente) {
                                            setCategoria(categoriaCorrespondente.categoria);
                                            // Atualizar o estado do idCategoria com o ID da categoria
                                            setIdCategoria(categoriaCorrespondente.id);
                                        }
                                    } else {
                                        // Caso nenhum risco seja selecionado ou encontrado, limpar os estados
                                        setCategoria('');
                                        setIdCategoria('');
                                    }
                                }}
                                freeSolo
                                options={riscos.map((option: any) => option.nome)}
                                renderInput={(params) => <TextField {...params} label="" />}
                            />



                        </Col>
                        <Col md={6} className='d-grid'>
                            <Label title='Categoria *' htmlFor="cat" />
                            <TextField
                                type="text"
                                id="cat"
                                label=""
                                variant="outlined"
                                style={{ marginRight: '5px' }}
                                value={categoria}
                                onChange={(e) => setCategoria(e.target.value)}
                            />
                        </Col>
                    </Row>
                    <Row className="my-4">
                        <Col md={4} >
                            <Label title='Meio de Propagação' htmlFor="propag" />
                            <Autocomplete
                                id='propag'
                                freeSolo
                                value={meiosPropagacao.find((mp:any) => mp.id === meioDePropagacao) || null}
                                options={meiosPropagacao}
                                getOptionLabel={(option:any) => option.nome || ''}
                                renderInput={(params:any) => <TextField {...params} label="" />}
                                onChange={(event, newValue) => {
                                    setMeioDePropagacao(newValue ? newValue.id : null);
                                }}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                            />

                        </Col>
                        <Col md={4} >
                            <Label title='Frequência' htmlFor="freq" />
                            <Autocomplete
                                id='freq'
                                freeSolo
                                value={frequencia}
                                onChange={(event, newValue: any) => {
                                    // Atualiza o estado com o novo valor, seja ele digitado livremente ou selecionado das opções
                                    setFrequencia(newValue);
                                }}
                                options={[
                                    'Nunca houve nenhum evento na indústria (onde a empresa está inserida).',
                                    'EVENTUAL',
                                    'Habitual',
                                    'HABITUAL E INTERMITENTE',
                                    'INTERMITENTE',
                                    'Ocasional',
                                    'PERMANENTE'
                                ]}
                                renderInput={(params) => <TextField {...params} label="" />}
                                // Não é necessário usar onInputChange a menos que você queira tratar especificamente mudanças durante a digitação
                                onInputChange={(event, newInputValue, reason) => {
                                    // Atualiza o estado apenas para alterações de input ("input" reason)
                                    if (reason === 'input') {
                                        setFrequencia(newInputValue);
                                    }
                                }}
                            />
                        </Col>
                        <Col md={4} >
                            <Label title='Classificação do Efeito' htmlFor="efeito" />
                            <Autocomplete
                                id='efeito'
                                freeSolo
                                value={classificacaoDoEfeito}
                                onChange={(event, newValue: any) => {
                                    // Atualiza o estado com o novo valor, seja ele digitado livremente ou selecionado das opções
                                    setClassificacaoDoEfeito(newValue);
                                }}
                                options={[
                                    'Atenção',
                                    'Severo',
                                    'Emergencial',
                                    'Moderado',
                                    'Leve',
                                    'NA'
                                ]}
                                renderInput={(params) => <TextField {...params} label="" />}
                                onInputChange={(event, newInputValue, reason) => {
                                    // Atualiza o estado apenas para alterações de input ("input" reason)
                                    if (reason === 'input') {
                                        setClassificacaoDoEfeito(newInputValue);
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                    <Row className="my-4">
                        <Col md={3} className='d-grid'>
                            <Label title='Limite de tolerância' htmlFor="ltol" />
                            <FormControl className='flex-row justify-content-start'>
                                <TextField value={limiteDeTolerancia ? limiteDeTolerancia.replace(/\D/g, '') : ''} onChange={(e) => setLimiteDeTolerancia(e.target.value)} type="text" id="ltol" label="" variant="outlined" style={{ marginRight: '5px' }} />

                                <Select
                                    labelId="demo-simple-select-label2"
                                    id="demo-simple-select2"
                                    value={limiteDeToleranciaUnd}
                                    onChange={(event) => setLimiteDeToleranciaUnd(event.target.value)}
                                >
                                    <MenuItem value="">Nenhum</MenuItem>
                                    {unidades.map((unidade: any) => (
                                        <MenuItem key={unidade.id} value={unidade.id}>{unidade.nome}</MenuItem>
                                    ))}
                                </Select>

                            </FormControl>
                        </Col>
                        <Col md={3} className='d-grid'>
                            <Label title='Nível de ação' htmlFor="nacao" />
                            <FormControl className='flex-row justify-content-start'>
                                <FormControl className='flex-row justify-content-start'>
                                    <TextField value={nivelDeAcao ? nivelDeAcao.replace(/\D/g, '') : ''} onChange={(e) => setNivelDeAcao(e.target.value)} type="text" id="nacao" label="" variant="outlined" style={{ marginRight: '5px' }} />
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={nivelDeAcaoUnd}
                                        onChange={(event) => setNivelDeAcaoUnd(event.target.value)}
                                        label=""
                                    >
                                        <MenuItem value="">Nenhum</MenuItem>
                                        {unidades.map((unidade: any) => (
                                            <MenuItem key={unidade.id} value={unidade.id}>{unidade.nome}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>


                            </FormControl>

                        </Col>

                        <Col md={3} className='d-grid'>
                            <Label title='Probabilidade' htmlFor="prob" />
                            <Select
                                labelId="demo-simple-select-label33"
                                id="selectProbabilidade"
                                value={probabilidade}
                                onChange={(event) => setProbabilidade(event.target.value)}
                                label=""
                            >
                                <MenuItem value="">Nenhum</MenuItem>
                                <MenuItem value="Muito Alta">Muito Alta</MenuItem>
                                <MenuItem value="Alta">Alta</MenuItem>
                                <MenuItem value="Média">Média</MenuItem>
                                <MenuItem value="Baixa">Baixa</MenuItem>
                            </Select>
                        </Col>
                        <Col md={3} className='d-grid'>
                            <Label title='Severidade' htmlFor="sev" />
                            <Select
                                labelId="demo-simple-select-label44"
                                id="selectSeveridade"
                                label=""
                                value={severidade}
                                onChange={(event) => setSeveridade(event.target.value)}
                            >
                                <MenuItem value="">Nenhum</MenuItem>
                                <MenuItem value="Muito Alta">Muito Alta</MenuItem>
                                <MenuItem value="Alta">Alta</MenuItem>
                                <MenuItem value="Média">Média</MenuItem>
                                <MenuItem value="Baixa">Baixa</MenuItem>
                            </Select>
                        </Col>
                    </Row>


                    <Row className="my-4">
                        <Col md={3} className='d-grid align-items-center'>
                            <Label title='Tempo de exposição' htmlFor="texp" />
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimeField
                                    label=""
                                    value={tempoDeExposicao}
                                    onChange={(newValue: any) => setTempoDeExposicao(newValue)}
                                    format="HH:mm"
                                />
                            </LocalizationProvider>
                        </Col>
                        <Col md={3} className='d-grid align-items-center'>
                            <Label title='Data da Medição' htmlFor="dateMedicao" />
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label=""
                                    value={dataDaMedicao}
                                    onChange={(newValue: Dayjs | null) => {
                                        setDataDaMedicao(newValue);
                                    }}
                                />
                            </LocalizationProvider>

                        </Col>
                        <Col md={3} className='d-grid'>
                            <Label title='Medição' htmlFor="med" />
                            <FormControl className='flex-row justify-content-start align-items-center'>
                                <TextField
                                    value={medicao ? medicao.replace(/\D/g, '') : ''}
                                    onChange={(e) => setMedicao(e.target.value)}
                                    type="text"
                                    id="med"
                                    label=""
                                    variant="outlined"
                                    style={{ marginRight: '5px' }}
                                />
                                <Select
                                    labelId="demo-simple-select-label221"
                                    id="demo-simple-select221"
                                    value={medicaoUnd}
                                    onChange={(event) => setMedicaoUnd(event.target.value)}
                                    label=""
                                >
                                    <MenuItem value="">Nenhum</MenuItem>
                                    <MenuItem value="dB">dB</MenuItem>
                                    <MenuItem value="dB(C)">dB(C)</MenuItem>
                                    <MenuItem value="Lux">Lux</MenuItem>
                                    <MenuItem value="mg/m³">mg/m³</MenuItem>
                                    <MenuItem value="PPM">PPM</MenuItem>
                                </Select>

                            </FormControl>
                        </Col>
                        <Col md={3} className='d-grid'>
                            <Label title='Medição atenuada' htmlFor="medAte" />
                            <FormControl className='flex-row justify-content-start align-items-center'>
                                <TextField
                                    value={medicaoAtenuada ? medicaoAtenuada.replace(/\D/g, '') : ''}
                                    onChange={(e) => setMedicaoAtenuada(e.target.value)}
                                    type="text"
                                    id="medAte"
                                    label=""
                                    variant="outlined"
                                    style={{ marginRight: '5px' }}
                                />
                                <Select
                                    labelId="demo-simple-select-label221"
                                    id="demo-simple-select221"
                                    label=""
                                    value={medicaoAtenuadaUnd}
                                    onChange={(event) => setMedicaoAtenuadaUnd(event.target.value)}
                                >
                                    <MenuItem value="">Nenhum</MenuItem>
                                    <MenuItem value="dB">dB</MenuItem>
                                    <MenuItem value="dB(C)">dB(C)</MenuItem>
                                    <MenuItem value="Lux">Lux</MenuItem>
                                    <MenuItem value="mg/m³">mg/m³</MenuItem>
                                    <MenuItem value="PPM">PPM</MenuItem>
                                </Select>
                            </FormControl>
                        </Col>
                    </Row>
                    <Row className="my-4">
                        <Col md={6}>
                            <Label title='Método' htmlFor="met" />
                            <Autocomplete
                                id='met'
                                freeSolo
                                value={metodo}
                                onChange={(event, newValue: any) => {
                                    setMetodo(newValue);
                                }}
                                onInputChange={(event, newInputValue) => {
                                    // Atualiza o estado baseado na entrada do usuário
                                    setMetodo(newInputValue);
                                }}
                                options={['BOMBA DE AMOSTRAGEM GILAIR 5', 'Dosimetria de Ruído', 'LUXÍMETRO', 'Gravimetria / Amostragem']}
                                renderInput={(params) => <TextField {...params} label="" />}
                            />

                        </Col>

                        <Col md={6} className='d-grid align-items-center'>
                            <Label title='Empresa que realizou a medição' htmlFor="empMed" />
                            <TextField value={empresaQueRealizouAMedicao} type="text" id="empMed" label="" variant="outlined" onChange={(event) => setEmpresaQueRealizouAMedicao(event.target.value)} />
                        </Col>
                    </Row>
                    <Divider />

                    <Row className="my-4">
                        <Col md={12}>
                            <Label title='Fontes geradoras' htmlFor="font" />
                            <Autocomplete
                                id='font'
                                freeSolo
                                value={fonteGeradora}
                                onChange={(event, newValue: any) => {
                                    setFonteGeradora(newValue);
                                }}
                                onInputChange={(event, newInputValue) => {
                                    // Atualiza o estado baseado na entrada do usuário
                                    setFonteGeradora(newInputValue);
                                }}
                                options={['Máquinas e Equipamentos', 'Substâncias Químicas']}
                                renderInput={(params) => <TextField {...params} label="" />}
                            />

                        </Col>
                    </Row>
                    <Divider />
                    <Row className="my-4">
                        <Col md={3} className='d-grid'>
                            <Label title='Utiliza EPI' htmlFor="utilEPI" />
                            <FormControl className=''>
                                <Select
                                    labelId="demo-simple-select-label2213"
                                    id="demo-simple-select2213"
                                    label=""
                                    value={utilizaEpi}
                                    onChange={(event) => setUtilizaEpi(event.target.value)}
                                >
                                    <MenuItem value="">Nenhum</MenuItem>
                                    <MenuItem value="sim">Sim</MenuItem>
                                    <MenuItem value="não">Não</MenuItem>
                                    <MenuItem value="não se aplica">Não se aplica</MenuItem>
                                </Select>
                            </FormControl>
                        </Col>
                        <Col md={3} className='d-grid'>
                            <Label title='Utiliza EPC' htmlFor="utilEPI" />
                            <FormControl className=''>
                                <Select
                                    labelId="demo-simple-select-label2219"
                                    id="demo-simple-select2219"
                                    label=""
                                    value={utilizaEpc}
                                    onChange={(event) => setUtilizaEpc(event.target.value)}
                                >
                                    <MenuItem value="">Nenhum</MenuItem>
                                    <MenuItem value="sim">Sim</MenuItem>
                                    <MenuItem value="não">Não</MenuItem>
                                    <MenuItem value="não se aplica">Não se aplica</MenuItem>
                                </Select>
                            </FormControl>
                        </Col>
                        <Col md={3} className='d-grid'>
                            <Label title='Instensidade' htmlFor="intens" />
                            <FormControl className=''>
                                <Select
                                    labelId="demo-simple-select-label2233"
                                    id="demo-simple-select2233"
                                    label=""
                                    value={intensidade}
                                    onChange={(event) => setIntensidade(event.target.value)}
                                >
                                    <MenuItem value="">Nenhum</MenuItem>
                                    <MenuItem value="Muito Alta">Muito Alta</MenuItem>
                                    <MenuItem value="Alta">Alta</MenuItem>
                                    <MenuItem value="Média">Média</MenuItem>
                                    <MenuItem value="Baixa">Baixa</MenuItem>
                                </Select>
                            </FormControl>
                        </Col>
                        <Col md={3} className='d-grid'>
                            <FormControl className=''>
                                <Label title='Técnica Utilizada' htmlFor="tecUtil" />
                                <Autocomplete
                                    id='tecUtil'
                                    freeSolo
                                    value={tecnicaUtilizada}
                                    onChange={(event, newValue: any) => {
                                        setTecnicaUtilizada(newValue);
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        setTecnicaUtilizada(newInputValue);
                                    }}
                                    options={['Medição direta no local de trabalho']}
                                    renderInput={(params) => <TextField {...params} label="" />}
                                />

                            </FormControl>
                        </Col>


                    </Row>
                    <Row className='my-4'>
                        <Col md={3} className='d-grid'>
                            <FormControl className=''>
                                <Label title='EPI' htmlFor="epi" />
                                <Autocomplete
                                    id='epi'
                                    freeSolo
                                    value={epi}
                                    onChange={(event, newValue: any) => {
                                        setEpi(newValue);
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        setEpi(newInputValue);
                                    }}
                                    options={[
                                        'Capacete',
                                        'Óculos de proteção',
                                        'Luvas de segurança',
                                        'Protetor auricular',
                                        'Máscara respiratória',
                                        'Botas de segurança',
                                        'Vestimenta de proteção']}
                                    renderInput={(params) => <TextField {...params} label="" />}
                                />

                            </FormControl>
                        </Col>
                        <Col md={4} className='d-grid'>
                            <FormControl className=''>
                                <Label title='Ação' htmlFor="action" />
                                <TextField value={acao} onChange={(e) => setAcao(e.target.value)} type="text" id="action" label="" variant="outlined" style={{ marginRight: '5px' }} />

                            </FormControl>
                        </Col>
                        <Col md={4} className='d-grid'>
                            <FormControl className=''>
                                <Label title='Evidências' htmlFor="font" />
                                <Autocomplete
                                    id='font'
                                    freeSolo
                                    value={evidencia}
                                    onChange={(event, newValue: any) => {
                                        setEvidencia(newValue);
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        setEvidencia(newInputValue);
                                    }}
                                    options={[
                                        'Fotos',
                                        'Medições sonoras',
                                        'Documentos de inspeção',
                                        'Relatórios de avaliação',
                                        'Testemunhos de testemunhas',
                                        'Vídeos',
                                        'Registros de incidentes',
                                    ]}
                                    renderInput={(params) => <TextField {...params} label="" />}
                                />
                            </FormControl>
                        </Col>
                    </Row>
                    <Divider />
                    <Row className="my-4">
                        <Col md={12} className='d-grid'>
                            <FormControl className=''>
                                <Label title='Possíveis danos à saúde' htmlFor="poss" />
                                <TextField value={possiveisDanosASaude} onChange={(e) => setPossiveisDanosASaude(e.target.value)} type="text" id="poss" label="" variant="outlined" style={{ marginRight: '5px' }} />


                            </FormControl>
                        </Col>
                    </Row>
                    <Row className="my-4">

                        <Col md={12} className='d-grid'>
                            <FormControl className=''>
                                <Label title='Medidas de controle existentes' htmlFor="medExi" />
                                <TextField value={medidasDeControleExistentes} onChange={(e) => setMedidasDeControleExistentes(e.target.value)} type="text" id="medExi" label="" variant="outlined" style={{ marginRight: '5px' }} />
                            </FormControl>
                        </Col>
                    </Row>
                    <Row className="my-4">

                        <Col md={12} className='d-grid'>
                            <FormControl className=''>
                                <Label title='Medidas de controle propostas' htmlFor="medProp" />
                                <TextField value={medidasDeControlePropostas} onChange={(e) => setMedidasDeControlePropostas(e.target.value)} type="text" id="medProp" label="" variant="outlined" style={{ marginRight: '5px' }} />
                            </FormControl>
                        </Col>
                    </Row>
                    <Row className="my-4">

                        <Col md={4} className='d-grid'>
                            <FormControl className=''>
                                <Label title='Cronograma' htmlFor="cronograma" />
                                <TextField value={cronograma} onChange={(e) => setCronograma(e.target.value)} type="text" id="cronograma" label="" variant="outlined" style={{ marginRight: '5px' }} />
                            </FormControl>
                        </Col>
                        <Col md={4} className='d-grid'>
                            <FormControl className=''>
                                <Label title='Formas de acompanhamento' htmlFor="formAcomp" />
                                <TextField value={formasDeAcompanhamento} onChange={(e) => setFormasDeAcompanhamento(e.target.value)} type="text" id="formAcomp" label="" variant="outlined" style={{ marginRight: '5px' }} />
                            </FormControl>
                        </Col>
                        <Col md={4} className='d-grid'>
                            <FormControl className=''>
                                <Label title='Aferição dos resultados' htmlFor="afe" />
                                <TextField value={afericaoDosResultados} onChange={(e) => setAfericaoDosResultados(e.target.value)} type="text" id="afe" label="" variant="outlined" style={{ marginRight: '5px' }} />
                            </FormControl>
                        </Col>
                    </Row>
                    <Row className="my-4">

                        <Col md={6} className='d-grid' >
                            <Label title='Probabilidade' htmlFor="prob" />
                            <Select
                                labelId="demo-simple-select-label33"
                                id="selectProbabilidadePgr"
                                label=""
                                value={probabilidadePgr}
                                onChange={(event) => setProbabilidadePgr(event.target.value)}
                            >
                                <MenuItem value="">Nenhum</MenuItem>
                                <MenuItem value="Muito Alta">Muito Alta</MenuItem>
                                <MenuItem value="Alta">Alta</MenuItem>
                                <MenuItem value="Média">Média</MenuItem>
                                <MenuItem value="Baixa">Baixa</MenuItem>
                            </Select>
                        </Col>
                        <Col md={6} className='d-grid'>
                            <Label title='Severidade' htmlFor="sev" />
                            <Select
                                labelId="demo-simple-select-label44"
                                id="selectSeveridadePgr"
                                label=""
                                value={severidadePgr}
                                onChange={(event) => setSeveridadePgr(event.target.value)}
                            >
                                <MenuItem value="">Nenhum</MenuItem>
                                <MenuItem value="Muito Alta">Muito Alta</MenuItem>
                                <MenuItem value="Alta">Alta</MenuItem>
                                <MenuItem value="Média">Média</MenuItem>
                                <MenuItem value="Baixa">Baixa</MenuItem>
                            </Select>
                        </Col>
                    </Row>
                    <Button className="btn-main mt-4" type="submit">Salvar</Button>
                </Form>


            </Main >
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </>
    );
}